import { DocumentSource, IncomingInvoiceReviewStatus, PaymentMethod, } from '@repo/database/browser';
/**
 * Ogni `DocumentSource` appartiene a esattamente un gruppo: il pannello filtri
 * mostra i gruppi e invia al backend l'unione delle fonti selezionate
 * (`sources`). Una nuova fonte va aggiunta qui, altrimenti il test di
 * copertura fallisce.
 */
export const DOCUMENT_SOURCE_GROUPS = {
    manual: [DocumentSource.MANUAL],
    sdi: [DocumentSource.ACUBE_SDI, DocumentSource.ACUBE_CASSETTO],
    imported: [DocumentSource.XML_IMPORT, DocumentSource.GENYA_XLS],
    integrations: [DocumentSource.JET_HR, DocumentSource.CGN_F24],
};
/**
 * Stati selezionabili nel pannello filtri delle Scadenze: combinati in OR fra
 * loro e in AND con gli altri filtri. `paid` = rata saldata; `expired` = non
 * saldata con scadenza prima di oggi (giorno italiano); `upcoming` = non
 * saldata con scadenza da oggi in poi.
 */
export const PAYMENT_SCHEDULE_FILTER_STATUSES = [
    'paid',
    'expired',
    'upcoming',
];
/**
 * Metodi di pagamento a carta (MP08 copre credito, debito e prepagata). Un
 * ACQUISTO pagato così è già addebitato quando nasce: lo Scadenzario lo
 * nasconde col filtro «Nascondi acquisti pagati con carta»
 * (`excludeCardPaidPurchases`, spento di default) e la riconciliazione
 * premia l'abbinamento con un movimento su un conto carta. Le vendite non si
 * nascondono: il cliente può pagare con carta più avanti.
 */
export const CARD_PAYMENT_METHODS = [
    PaymentMethod.MP08,
];
/**
 * Stadi del workflow «Fatture arrivate» selezionabili nel pannello Filtri
 * della lista documenti (`reviewStage`, CSV): combinati in OR fra loro e in
 * AND con gli altri filtri. Gli stessi tre contatori della card della
 * dashboard; una fattura PAID o CANCELLED non è in nessuno stadio.
 */
export const INCOMING_REVIEW_STAGES = [
    'TO_VERIFY',
    'TO_APPROVE',
    'TO_PAY',
];
/**
 * Stato di revisione di ogni stadio: unica fonte per il filtro della lista e
 * per i contatori SQL della card «Fatture arrivate». «Da pagare» sono le
 * fatture APPROVED non ancora pagate.
 */
export const INCOMING_REVIEW_STAGE_REVIEW_STATUS = {
    TO_VERIFY: IncomingInvoiceReviewStatus.TO_VERIFY,
    TO_APPROVE: IncomingInvoiceReviewStatus.TO_APPROVE,
    TO_PAY: IncomingInvoiceReviewStatus.APPROVED,
};
//# sourceMappingURL=document-filters.js.map